/**
 * TENANT SELECTOR - Dropdown for global_admin to filter by tenant
 */

import React, { useState, useEffect } from 'react';
import { Users } from 'lucide-react';
import apiClient from '../../../lib/apiClient';

export default function TenantSelector({ value, onChange, className = '' }) {
  const [tenants, setTenants] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadTenants();
  }, []);

  const loadTenants = async () => {
    try {
      // Call the correct API endpoint (under /admin/financials not /admin)
      const response = await apiClient.get('/admin/financials/tenants');

      if (response.data?.data?.tenants) {
        setTenants(response.data.data.tenants);
        console.log('✅ Tenants loaded for selector:', response.data.data.tenants.length);
      }
    } catch (err) {
      console.error('Error loading tenants:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <Users className="w-4 h-4 text-gray-400 flex-shrink-0" />
      <label className="text-sm font-medium text-gray-700 whitespace-nowrap">Tenant:</label>
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={loading}
        className="text-sm border border-gray-300 rounded px-3 py-1 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 min-w-[200px]"
      >
        <option value="all">All Tenants</option>
        {loading ? (
          <option disabled>Loading...</option>
        ) : (
          tenants.map((tenant) => (
            <option key={tenant.tenant_id} value={tenant.tenant_id}>
              {tenant.name || tenant.email || `Tenant ${tenant.tenant_id.substring(0, 8)}`}
            </option>
          ))
        )}
      </select>
    </div>
  );
}
